/* eslint-disable @typescript-eslint/no-empty-interface */
import { createTheme, Theme, ThemeOptions } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'
import { components } from './components'
import { palette } from './palette'

function spacing(number: number): string {
  return `${number * 8}px`
}

// Add color options to custom palettes
interface BlackPaletteColors {
  main: string
  medium: string
  disabled: string
  inactive: string
  icons: string
}

interface WhitePaletteColors {
  primary: string
  main: string
  disabled: string
  inactive: string
  light: string
}

interface GrayPaletteColors {
  dark: string
  medium: string
  light: string
  main: string
  divider: string
  outline: string
  inactive: string
  chipMedium: string
  chipLight: string
}

interface BackgroundPaletteColors {
  main: string
  dark: string
  light: string
  input: string
}

interface HoverPaletteColors {
  main: string
  black: string
  blackLight: string
  white: string
  whiteLight: string
}

interface DarkPaletteColors {
  main: string
  black: string
  blackLight: string
  divider: string
  light: string
  white: string
  whiteExtra: string
}

// Extend the default material-ui palette using module augmentation
// https://material-ui.com/guides/typescript/#customization-of-theme
// https://material-ui.com/customization/palette/#adding-new-colors

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    black: BlackPaletteColors
    white: WhitePaletteColors
    gray: GrayPaletteColors
    backgroundStyle: BackgroundPaletteColors
    hoverOverlay: HoverPaletteColors
    dark: DarkPaletteColors
  }

  interface PaletteOptions {
    black?: BlackPaletteColors
    white?: WhitePaletteColors
    gray?: GrayPaletteColors
    backgroundStyle?: BackgroundPaletteColors
    hoverOverlay?: HoverPaletteColors
    dark?: DarkPaletteColors
  }

  interface PaletteColor extends ColorPartial {}
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    gray: true
    white: true
  }
  interface ButtonPropsSizeOverrides {
    tiny: true
  }
}

declare module '@mui/material/ToggleButtonGroup' {
  interface ToggleButtonGroupPropsColorOverrides {
    gray: true
  }
}

declare module '@mui/material/ToggleButton' {
  interface ToggleButtonPropsColorOverrides {
    gray: true
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    gray: true
  }
}

export { Theme, ThemeOptions } from '@mui/material/styles'

export const RobotenTheme: ThemeOptions = {
  components,
  palette,
  spacing,
}

export const createRobotenTheme = (theme: ThemeOptions): Theme => {
  return createTheme(deepmerge(RobotenTheme, theme))
}
